import { PhasrRecommendationsWebComponent } from './component/PhasrRecommendationsWebComponent';
import { WEB_COMPONENT_PHASR_RECOMMENDATIONS } from '../../webcomponents.constants';

export { PhasrRecommendationsWebComponent };

window.customElements.define(WEB_COMPONENT_PHASR_RECOMMENDATIONS, PhasrRecommendationsWebComponent);
